import React, { useState, useEffect } from 'react';
import { StylovyzeDialog } from '@innovyze/stylovyze';
import { TextField, Grid, DialogProps } from '@mui/material';
import { useGlobalization } from '@Translations';
import { isAlphanumericName } from '@Utils/nameValidation';

interface RenameDialogProps {
	open: boolean;
	currentName: string;
	onClose: (saved: boolean, newName: string) => void;
}

export const RenameDialog = ({ open, currentName, onClose }: RenameDialogProps) => {
	const { t } = useGlobalization();
	const [newName, setNewName] = useState(currentName);
	const [nameError, setNameError] = useState('');

	useEffect(() => {
		setNewName(currentName);
		setNameError('');
	}, [currentName, open]);

	const validateName = (value: string) => {
		if (!value.trim()) {
			return t('Required');
		}
		if (!isAlphanumericName(value)) {
			return t('Only alphanumeric characters are allowed');
		}
		return '';
	};

	const handleNameChange = (value: string) => {
		setNewName(value);
		setNameError(validateName(value));
	};

	const handleConfirm = () => {
		const error = validateName(newName);
		setNameError(error);
		if (error) {
			return;
		}
		onClose(true, newName.trim());
	};

	const handleCancel = () => {
		onClose(false, '');
	};

	const dialogProps: DialogProps = {
		open,
		fullWidth: true,
		maxWidth: 'sm',
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onClose: () => {},
	};

	return (
		<StylovyzeDialog
			dialogProps={dialogProps}
			title="Rename Failure Definition"
			open={open}
			cancelText="Cancel"
			onCancel={handleCancel}
			confirmText="OK"
			onConfirm={handleConfirm}
			confirmButtonProps={{
				disabled: nameError.length !== 0 || newName.trim() === '',
			}}>
			<Grid container>
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="Title"
						variant="outlined"
						value={newName}
						error={nameError.length !== 0}
						helperText={nameError || ' '}
						onChange={e => handleNameChange(e.target.value)}
					/>
				</Grid>
			</Grid>
		</StylovyzeDialog>
	);
};
